import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope1Form = ({ disabled }) => (
  <ScopeEmissionForm
    scopeKey="scope1"
    label="Scope 1 Emissions"
    disabled={disabled}
  />
);

export default Scope1Form;
